/**
 * Edge lengths, in mm on the image plane, a checkerboard comparison may
 * tile a fused pair with. The pattern is pinned to the anatomy, so a tile
 * covers the same tissue at every zoom; these steps span one small
 * structure to a whole region.
 */
export const CHECKERBOARD_TILE_SIZES_MM: ReadonlyArray<number> = [
    10, 20, 50, 100, 150, 200,
];

export const DEFAULT_CHECKERBOARD_TILE_SIZE_MM = 100;

/**
 * Whether `sizeMm` is a length a checkerboard tile can have: a finite,
 * strictly positive number. A zero or negative tile would divide the
 * pattern by nothing.
 */
function isValidCheckerboardTileSizeMm(sizeMm: number): boolean {
    return Number.isFinite(sizeMm) && sizeMm > 0;
}

/** Throws unless `sizeMm` is a length a checkerboard tile can have. Nothing is clamped. */
export function assertValidCheckerboardTileSizeMm(sizeMm: number): void {
    if (!isValidCheckerboardTileSizeMm(sizeMm)) {
        throw new Error(
            `Checkerboard tile size must be a positive length in mm, got ${sizeMm}.`
        );
    }
}
